/**
 * Shared revision check for the single-slot entity slices (BSE, contract, bid).
 *
 * `lastChanged` is an ISO timestamp, but its source differs — edits stamp the
 * client clock (`new Date().toISOString()`) while loads carry the server
 * `modifiedAt`. Comparing across sources is exposed to clock skew, so we drop
 * only on a STRICTLY older timestamp. Ties and unparseable values compare false
 * and therefore apply — which also preserves the edit-thunk failure path that
 * returns the unchanged `lastChanged` alongside an inline error message.
 */
export const isOlderRevision = (
  incoming: { lastChanged: string },
  current: { lastChanged: string }
): boolean => new Date(incoming.lastChanged) < new Date(current.lastChanged);

// SM-1162: comparing revisions across ids kept the previously edited contract in the editor.
export const isOlderRevisionOfSameEntity = (
  incoming: { id: string; lastChanged: string },
  current: { id: string; lastChanged: string }
): boolean => incoming.id === current.id && isOlderRevision(incoming, current);
